import {RouterPaths} from "../routerPaths";
import PublicRoute from "../PublicRoute";
import {importPages} from "../lazyRoute";

const authRoutes = [
    {
        path: RouterPaths.LOGIN,
        element: <PublicRoute element={importPages.Login}/>,
    },
    {
        path: RouterPaths.REGISTRATION,
        element: <PublicRoute element={importPages.Registration}/>,
    },
    {
        path: RouterPaths.FORGOTPASSWORD,
        element: <PublicRoute element={importPages.ForgotPassword}/>,
    },
    {
        path: RouterPaths.RESETPASSWORD,
        element: <PublicRoute element={importPages.ResetPassword}/>,
    },
    {
        path: RouterPaths.CREATENEWPASSWORD,
        element: <PublicRoute element={importPages.CreateNewPassword}/>,

    },
    {
        path: RouterPaths.TWOFACTORAUTHENTICATION,
        element: <PublicRoute element={importPages.TwoFactorAuthentication}/>,
    },
]
export default authRoutes;